const SET_SCROLL_POSITION = (state, position) => {
    state.scrollPosition = position
}

export default {
    SET_SCROLL_POSITION
}
